import { FloatingFormItem, PhoneFormField } from '@/components/_common';
import {
  CompanySintegraFormValues,
  NatureType,
  StructureType,
} from '@/core/domain/sintegra/Sintegra.types';
import {
  useDefaultEmptyFieldError,
  useDefaultMaxLengthFieldError,
} from '@/hooks';
import { Checkbox, Col, Form, FormInstance, Input, Row, Select } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<CompanySintegraFormValues>;
}

const CompaniesSintegraForm = ({ form }: Props) => {
  const intl = useIntl().formatMessage;

  const requiredField = useDefaultEmptyFieldError();
  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  return (
    <Form form={form} name="companySintegra">
      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <FloatingFormItem
            name="sintegraStructureCode"
            label={intl({
              id: 'companies.sintegra.structure',
            })}
            rules={[requiredField]}
          >
            <Select
              options={[
                {
                  label: intl({ id: 'companies.sintegra.structure.icms30' }),
                  value:
                    StructureType.CONVENIO_57_95_VERSAO_31_99_ALTERACOES_ATE_30_02,
                },
                {
                  label: intl({ id: 'companies.sintegra.structure.icms142' }),
                  value:
                    StructureType.CONVENIO_57_95_VERSAO_69_02_ALTERACOES_ICMS_142_02,
                },
                {
                  label: intl({ id: 'companies.sintegra.structure.icms76' }),
                  value: StructureType.CONVENIO_57_95_ALTERACOES_ICMS_76_03,
                },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem
            name="sintegraNatureCode"
            label={intl({
              id: 'companies.sintegra.nature',
            })}
            rules={[requiredField]}
          >
            <Select
              options={[
                {
                  label: intl({
                    id: 'companies.sintegra.nature.interstatesSubstitution',
                  }),
                  value: NatureType.INTERSTATE_ONLY_SUBSTITUTION_TAX,
                },
                {
                  label: intl({
                    id: 'companies.sintegra.nature.interstatesWithout',
                  }),
                  value: NatureType.INTERSTATE_WITH_OR_WITHOUT_SUBSTITUTION_TAX,
                },
                {
                  label: intl({
                    id: 'companies.sintegra.nature.allOperations',
                  }),
                  value: NatureType.ALL_OPERATIONS_OF_INFORMER,
                },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem
            name="responsibleName"
            label={intl({
              id: 'companies.sintegra.name',
            })}
            rules={[requiredField, defaultMaxLenghtFieldError(30)]}
          >
            <Input maxLength={28} showCount />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <PhoneFormField name={'responsibleContactPhone'} label={'Telefone'} />
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem name="generateRecord51" valuePropName="checked">
            <Checkbox>
              {intl({
                id: 'companies.sintegra.record51',
              })}
            </Checkbox>
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem name="generateRecord53" valuePropName="checked">
            <Checkbox>
              {intl({
                id: 'companies.sintegra.record53',
              })}
            </Checkbox>
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default CompaniesSintegraForm;
